// extracted by mini-css-extract-plugin
module.exports = {"Root":"ZeMDhw4mIch9BgY4LEq7vg=="};